import axiosInstance from './axiosInstance';

const API_BASE_URL = '/admin/broadcasts';

export const broadcastService = {
  // List all broadcasts with filtering
  getBroadcasts: async (params = {}) => {
    try {
      const response = await axiosInstance.get(API_BASE_URL, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get single broadcast
  getBroadcastById: async (id) => {
    try {
      const response = await axiosInstance.get(`${API_BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Create new broadcast
  createBroadcast: async (data) => {
    try {
      const response = await axiosInstance.post(API_BASE_URL, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update broadcast
  updateBroadcast: async (id, data) => {
    try {
      const response = await axiosInstance.put(`${API_BASE_URL}/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete broadcast
  deleteBroadcast: async (id) => {
    try {
      const response = await axiosInstance.delete(`${API_BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};
